"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CareerApplicationSchema = exports.ApplicationStatusEnum = exports.CareerPositionSchema = exports.CareerAdvertSchema = exports.PositionStatusEnum = exports.CustomQuestionSchema = exports.QuestionTypeEnum = void 0;
const zod_1 = require("zod");
exports.QuestionTypeEnum = zod_1.z.enum(['short_text', 'radio', 'checkbox']);
exports.CustomQuestionSchema = zod_1.z.object({
    id: zod_1.z.string(),
    label: zod_1.z.string().min(1),
    type: exports.QuestionTypeEnum,
    options: zod_1.z.array(zod_1.z.string()).default([]),
    required: zod_1.z.boolean().default(false),
});
exports.PositionStatusEnum = zod_1.z.enum(['open', 'closed']);
/** Text + layout of the job advert, drawn over `imageUrl` by the page. */
exports.CareerAdvertSchema = zod_1.z.object({
    headline: zod_1.z.string().default(''),
    kicker: zod_1.z.string().default("We're hiring"),
    chips: zod_1.z.array(zod_1.z.string()).default([]),
    cta: zod_1.z.string().default('Apply now'),
    layout: zod_1.z.enum(['bottom', 'split', 'poster']).default('bottom'),
    accent: zod_1.z.string().optional(),
});
exports.CareerPositionSchema = zod_1.z.object({
    tenantId: zod_1.z.string(), positionId: zod_1.z.string(),
    title: zod_1.z.string().min(1), description: zod_1.z.string().default(''),
    employmentType: zod_1.z.enum(['full_time', 'part_time']),
    locationIds: zod_1.z.array(zod_1.z.string()).default([]),
    commuteQuestion: zod_1.z.object({ enabled: zod_1.z.boolean(), prompt: zod_1.z.string() }).default({ enabled: false, prompt: '' }),
    customQuestions: zod_1.z.array(exports.CustomQuestionSchema).default([]),
    status: exports.PositionStatusEnum.default('open'),
    openings: zod_1.z.number().int().default(1),
    applicantCount: zod_1.z.number().int().default(0),
    // --- 2026-10-08, Ruby job advert (all optional, additive) ---
    /** Advert photo made by Ruby (image.job_ad) or uploaded — no text baked in. */
    imageUrl: zod_1.z.string().optional(),
    /** Editable text laid over the photo; the picture never carries lettering. */
    advert: exports.CareerAdvertSchema.optional(),
    createdAt: zod_1.z.number(), updatedAt: zod_1.z.number(),
});
exports.ApplicationStatusEnum = zod_1.z.enum(['new', 'shortlisted', 'hired', 'rejected']);
exports.CareerApplicationSchema = zod_1.z.object({
    tenantId: zod_1.z.string(), positionId: zod_1.z.string(), applicationId: zod_1.z.string(),
    name: zod_1.z.string().min(1), email: zod_1.z.string().email(), phone: zod_1.z.string().default(''),
    locationId: zod_1.z.string().default(''), cvUrl: zod_1.z.string().default(''),
    coverNote: zod_1.z.string().default(''), availability: zod_1.z.string().default(''), commuteAnswer: zod_1.z.string().default(''),
    answers: zod_1.z.array(zod_1.z.object({ questionId: zod_1.z.string(), value: zod_1.z.string().optional(), values: zod_1.z.array(zod_1.z.string()).optional() })).default([]),
    status: exports.ApplicationStatusEnum.default('new'),
    hiredUserId: zod_1.z.string().nullish(),
    createdAt: zod_1.z.number(), updatedAt: zod_1.z.number(),
});
//# sourceMappingURL=careers.schema.js.map